import $ from "jquery";
import { allowedLocales } from "scripts/utils/constants";

$.ajaxPrefilter(function ajaxPrefilterHandler(options, originalOptions, xhr) {
  if (options.crossDomain) return
  const token = document
    .querySelector('meta[name="csrf-token"]')
    .getAttribute("content")
  if (token) xhr.setRequestHeader("X-CSRF-TOKEN", token)
})

const getPageLocale = () => {
  let locale = document.documentElement.lang || 'en';
  if (!(locale in allowedLocales)) {
    locale = allowedLocales.uk;
  }
  return locale
}

const jqueryAjaxMiddleware = (config) => {
  // const { url, method, data, headers } = config;

  return new Promise((resolve, reject) => {
    $.ajax({
      // url,
      // method,
      // data,
      // headers,
      ...config,
      dataType: "json",
      success: (response) => resolve(response),
      error: (error) => reject(error),
    });
  });
};

const axiosApi = (url, config) => {
    const { method, data, headers = {} } = config;

    return jqueryAjaxMiddleware({
      ...config,
        url,
        type: method,
        data: data || null,
        headers: {
          'Accept-Language': getPageLocale(),
          ...headers,
        },
    });
};

const methods = ['GET', 'POST', 'PUT'];

methods.forEach(method => {
    axiosApi[method.toLocaleLowerCase()] = (url, config) => {
        if (typeof url !== 'string') {
            config = url;
            url = config.url;
        }
        const axiosConfig = config ? { ...config, method } : { method };
        return axiosApi(url, axiosConfig);
    };
});

export default axiosApi;